module.exports = __webpack_public_path__ + "assets/img/jiesuan.00e1cd65.png";